import { event } from "./gtag"

export default function getIOSVersion(): string {
  const userAgent = navigator.userAgent
  const iOSRegex = /iP(hone|od|ad);.*OS\s([\d_]+)/
  const iOSMatch = iOSRegex.exec(userAgent)

  if (iOSMatch) {
    return iOSMatch[2].replace(/_/g, ".")
  } else {
    return "unknown"
  }
}

export function checkAndUpdateIOSVersion(t: any): void {
  const userAgent: string = window.navigator.userAgent
  const iosVersionRegExp = /iP(hone|od|ad) OS (\d+(_\d+)?)/
  const match: RegExpMatchArray | null = userAgent.match(iosVersionRegExp)

  if (match && match.length > 2) {
    const version: string = match[2].replace("_", ".")
    const parsedVersion: number = parseFloat(version)

    if (parsedVersion < 16.4) {
      event({
        action: "notifications_not_supported",
        category: "notifications",
        label: "notifications feature is not supported on this device",
        value: "iOS " + parsedVersion,
      })
      alert(t.notifications.updateTo164)
    }
  }
}
